import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Calendar, User, ArrowRight } from 'lucide-react';
import { mockArticles } from '../utils/mockData';

const Articles = () => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = ['all', 'health', 'nutrition', 'training', 'breeding'];

  const filteredArticles = selectedCategory === 'all' 
    ? mockArticles 
    : mockArticles.filter(article => article.category === selectedCategory);

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4">
        <h1 className="text-4xl md:text-5xl font-bold text-center mb-4 text-gray-900">
          {t('articles.title')}
        </h1>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-6 py-2 rounded-full font-medium transition-all ${
                selectedCategory === category
                  ? 'bg-red-600 text-white shadow-lg'
                  : 'bg-white text-gray-700 hover:bg-red-50 hover:text-red-600 border border-gray-200'
              }`}
            >
              {t(`articles.categories.${category}`)}
            </button>
          ))}
        </div>

        {/* Articles Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {filteredArticles.map((article) => (
            <div
              key={article.id}
              className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
            >
              <img
                src={article.image}
                alt={article[`title${currentLang.charAt(0).toUpperCase() + currentLang.slice(1)}`]}
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <div className="flex items-center justify-between mb-3">
                  <span className="px-3 py-1 bg-red-100 text-red-600 text-xs font-semibold rounded-full">
                    {t(`articles.categories.${article.category}`)}
                  </span>
                  <div className="flex items-center text-gray-500 text-sm">
                    <Calendar size={14} className="mr-1" />
                    {new Date(article.date).toLocaleDateString()}
                  </div>
                </div>
                <h3 className="text-xl font-semibold mb-2 text-gray-900 line-clamp-2">
                  {article[`title${currentLang.charAt(0).toUpperCase() + currentLang.slice(1)}`]}
                </h3>
                <div className="flex items-center text-gray-600 text-sm mb-3">
                  <User size={14} className="mr-1" />
                  <span>{article.author}</span>
                </div>
                <p className="text-gray-600 mb-4 line-clamp-3">{article.excerpt}</p>
                <button className="flex items-center text-red-600 hover:text-red-700 font-medium transition-colors">
                  {t('articles.readMore')}
                  <ArrowRight size={16} className="ml-2" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Articles;
